import { PaymentsSetDistributionSettingsProcessedItemsReducer } from './types';

export const paymentsSetDistributionSettingsProcessedItemsReducer: PaymentsSetDistributionSettingsProcessedItemsReducer =
  (state, action) => {
    const { items } = action.payload;

    return {
      ...state,
      paymentsDistributionSettingsProcessedItems: items,
    };
  };
